import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading, PrimaryButton } from './ui/UI';
const plans = [{
  name: 'Validation Snapshot',
  desc: 'Focused first report. Top validated exposures, paths, and control observations.',
  note: 'Start here'
}, {
  name: 'Core Validation',
  desc: 'Recurring exposure and attack-path validation across cloud, identity, SaaS, and code.',
  note: 'Most teams',
  highlight: true
}, {
  name: 'Control Validation',
  desc: 'BAS-lite checks and ongoing control evidence — detect, block, log, alert.',
  note: 'Add-on'
}, {
  name: 'AI Security Validation',
  desc: 'AI app, RAG, copilot, and agent validation. Prompt injection, leakage, tool misuse.',
  note: 'Add-on'
}, {
  name: 'Frontier Gateway',
  desc: 'Safe, policy-controlled access for frontier cyber models to reason over your environment.',
  note: 'Add-on'
}, {
  name: 'MSSP / Partner',
  desc: 'Multi-tenant validation, white-label reporting, bulk onboarding, partner economics.',
  note: 'Partner program'
}];
export function Pricing() {
  return <section id="pricing" className="relative w-full py-32 border-t border-white/5" data-id="element-1217">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1218">
        <SectionLabel number="01" label="Modular Plans" className="mb-8" data-id="element-1219" />

        {/* Modular plan preview */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 mb-24" data-id="element-1220">
          {plans.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className={`relative p-7 rounded-2xl border transition-colors ${p.highlight ? 'bg-gradient-to-br from-[#1a8fd4]/10 to-[#0a0d12] border-[#1a8fd4]/40' : 'bg-[#070a0e] border-white/[0.06] hover:border-white/15'}`} data-id="element-1221">
              <div className="flex items-start justify-between gap-4 mb-4" data-id="element-1222">
                <h3 className="text-lg font-semibold text-white tracking-tight" data-id="element-1223">
                  {p.name}
                </h3>
                <span className={`font-mono text-[10px] uppercase tracking-[0.3em] whitespace-nowrap pt-1.5 ${p.highlight ? 'text-[#1a8fd4]' : 'text-white/40'}`} data-id="element-1224">
                  {p.note}
                </span>
              </div>
              <p className="text-sm text-white/60 leading-relaxed" data-id="element-1225">{p.desc}</p>
            </motion.div>)}
        </div>

        {/* Pricing philosophy */}
        <div className="rounded-2xl bg-[#070a0e] border border-white/5 p-8 md:p-12" data-id="element-1226">
          <p className="font-mono text-xs uppercase tracking-widest text-[#1a8fd4] mb-4" data-id="element-1227">
            Pricing Philosophy
          </p>
          <p className="text-2xl md:text-3xl text-white leading-snug max-w-3xl tracking-tight mb-8" data-id="element-1228">
            Disruptive pricing. Serious validation. The goal is simple — make
            continuous validation normal.
          </p>
          <p className="text-sm text-white/50 leading-relaxed max-w-2xl mb-8" data-id="element-1229">
            Early access pricing will be shaped by scope, usage, validation
            depth, and customer feedback.
          </p>
          <PrimaryButton href="/early-access" size="lg" data-id="element-1230">
            Request Early Access
          </PrimaryButton>
        </div>
      </div>
    </section>;
}